import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnum = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 6.5,
		fill: "#FAF5FF",
		stroke: "#834DF0"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.49023 11.5H10.5102V10.585H6.48023V8.435H10.0702V7.515H6.48023V5.415H10.4102V4.5H5.49023V11.5Z",
		fill: "#834DF0"
	})]
});
export default SvgEnum;
